import type { IntlShape } from 'react-intl-next';

import {
	DefaultExtensionProvider,
	type ExtensionProvider,
} from '@atlaskit/editor-common/extensions';

import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';

import { fetchSnippets } from '../services/blockServiceClient.ts';
import { type Snippet } from '../snippetTypes.ts';

import { snippetExtensionManifest } from './snippetExtensionManifest.tsx';

export const snippetExtensionProvider = async (
	intl: IntlShape,
	onOpenTemplatePanel?: () => void,
): Promise<ExtensionProvider> => {
	try {
		const snippets: Snippet[] = await fetchSnippets();

		if (!snippets || snippets.length === 0) {
			if (!onOpenTemplatePanel) {
				return new DefaultExtensionProvider([]);
			}
		}

		const manifest = snippetExtensionManifest({
			snippets: snippets || [],
			intl,
			onOpenTemplatePanel,
		});

		return new DefaultExtensionProvider([manifest]);
	} catch (error) {
		getMonitoringClient().submitError(error as Error, {
			attribution: Attribution.INTEGRATIONS,
		});
		return new DefaultExtensionProvider([]);
	}
};
